import * as buttons from "./buttons";
import * as colors from "./colors";

const shared = {
  ...colors,
  buttons
};

export default shared;